import React from 'react';
import { AdvancedImage, lazyload, placeholder, responsive } from '@cloudinary/react';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import { LoginHeroImageType } from '@appTypes/heroes/heroWithTitleImageBodyAndLoginType';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import { ImageBox } from '../styles';

export const LoginHeroImage = ({ images }: { images: LoginHeroImageType[] }) => {
  if (!images) return null;
  for (const image of images) {
    if (image.type === 'cloudinaryImage') {
      const cloudinaryImage = <CloudinaryImage image={image} key={image.key} />;
      if (cloudinaryImage) {
        return cloudinaryImage;
      }
    }
  }

  return null;
};

const CloudinaryImage = ({ image }: { image: CloudinaryImageType }) => {
  const { getResponsiveImage } = useCloudinary();
  const cldImage = getResponsiveImage(image?.public_id || image?.publicId);
  return cldImage ? (
    <ImageBox>
      <AdvancedImage
        alt={image?.altText}
        cldImg={cldImage}
        plugins={[
          lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 }),
          responsive({ steps: 200 }),
          placeholder({ mode: 'blur' }),
        ]}
      />
    </ImageBox>
  ) : null;
};
